<template>
  <div class="page" v-if="$conFun.clientWidth() > 768">
    <Nav isActive="6" />
    <div class="pageWD pt100">
      <div class="f18 c9 htop" style="padding: 20px 0">
        首页>云学资讯>资讯详情
      </div>
    </div>
    <div class="pagebox pageWD">
      <div class="p20 flex-sb">
        <div class="new_left">
          <new-detail :id="id" :detail="detail" />
        </div>
        <div class="new_rig" v-if="!isScroll">
          <div v-for="(item, index) in xwlist" :key="index">
            <new-item-r
              width="136px"
              height="84px"
              lnheight="60px"
              :item="item"
              :index="index"
              @tapDetail="tapDetailMe"
            />
          </div>
        </div>
        <div class="new_rig scrollCsss" v-else :style="{ right: ht + 'px' }">
          <div v-for="(item, index) in xwlist" :key="index">
            <new-item-r
              width="136px"
              height="84px"
              lnheight="60px"
              :item="item"
              :index="index"
              @tapDetail="tapDetailMe"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page" v-else>
    <Nav />
    <div class="mbpage">
      <div class="f18 c9 htop" style="padding: 20px">
        首页>云学资讯>资讯详情
      </div>
      <div class="pagebox">
        <div class="p20">
          <new-detail :id="id" :detail="detail" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articleList, articleDetail } from "@/api/api";
import Nav from "@/components/Nav.vue";
import Fotter from "@/components/Fotter.vue";
import NewItem from "@/components/NewItem.vue";
import NewItemR from "@/components/NewItemR.vue";
import NewDetail from "@/components/NewDetail.vue";
export default {
  name: "Nes",
  components: { Nav, NewItem, NewItemR, NewDetail, Fotter },
  data() {
    return {
      ht: null,
      isScroll: false,
      id: "1",
      xwlist: [],
      id: this.$route.query.id || null,
      detail: null,
    };
  },
  created() {
    this.getArticleList();
    this.getArticleDetail(this.id);
    this.ht = (document.documentElement.clientWidth - 1200) / 2 + 10;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log(scrollTop);
      if (scrollTop > 200) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
    getSrc() {
      var s = "/News?lmid=" + this.lmid;
      return s;
    },
    tapDetailMe(data) {
      console.log(data);
      this.xwlist.forEach((item) => {
        item.tempview = "";
      });
      this.xwlist[data.index].tempview = 1;
      this.getArticleDetail(data.aid);
    },
    tapMe() {
      this.$router.push({ path: "/New" });
    },
    tapChangeNews(id) {
      this.id = id;
      this.getArticleDetail(id);
    },
    getArticleDetail(id) {
      var that = this;
      var data = {
        id: id,
      };
      articleDetail(data).then((res) => {
        that.detail = res.body.result;
      });
    },
    getArticleList() {
      var that = this;
      articleList().then((res) => {
        that.xwlist = res.body.result.forumList;
        that.xwlist.forEach(function (item, index) {
          if (index % 3 == "0") {
            item.promType = "#DCE3EE";
          }
          if (index % 3 == "1") {
            item.promType = "#BABED1";
          }
          if (index % 3 == "2") {
            item.promType = "#2A579E";
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.new_left {
  width: 730px;
  border-right: 1px solid #eeeeee;
  padding-right: 20px;
}
.new_rig {
  flex: 1;
  margin-left: 20px;
  overflow-y: scroll;
}
.scrollCsss {
  position: fixed;
  width: 410px;
  z-index: 4;
  top: 95px;
  bottom: 20px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/news/detail.vue